import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';
import type { AuthIntent } from '@/features/auth/internal/types/social-auth';

type SocialAuthEventsInput = {
  intent: AuthIntent;
  provider: string;
  umsGuid?: string | null;
};

export const emitSocialAuthEvents = ({
  intent,
  provider,
  umsGuid,
}: SocialAuthEventsInput): void => {
  if (intent === 'signup') {
    emitGTMEvent('USER_SIGNUP', { social_provider: provider, umsGuid });
  }
  emitGTMEvent('USER_LOGIN', { social_provider: provider });
};
